"use strict";

var _ELEMENT_NAME_TAG_MAP;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;

var utilities_1 = require("../utilities");

var ELEMENT_NAME_TAG_MAP = (_ELEMENT_NAME_TAG_MAP = {}, _defineProperty(_ELEMENT_NAME_TAG_MAP, 'block-quote', 'blockquote'), _defineProperty(_ELEMENT_NAME_TAG_MAP, 'heading-one', 'h1'), _defineProperty(_ELEMENT_NAME_TAG_MAP, 'heading-two', 'h2'), _defineProperty(_ELEMENT_NAME_TAG_MAP, 'list-item', 'li'), _defineProperty(_ELEMENT_NAME_TAG_MAP, 'numbered-list', 'ol'), _defineProperty(_ELEMENT_NAME_TAG_MAP, 'bulleted-list', 'ul'), _defineProperty(_ELEMENT_NAME_TAG_MAP, "paragraph", 'p'), _ELEMENT_NAME_TAG_MAP);
var MARK_ELEMENT_TAG_MAP = {
  strikethrough: ['s'],
  bold: ['strong'],
  underline: ['u'],
  italic: ['i'],
  code: ['pre', 'code']
};
exports.config = {
  markMap: MARK_ELEMENT_TAG_MAP,
  elementMap: ELEMENT_NAME_TAG_MAP,
  elementTransforms: {},
  elementAttributeTransform: function elementAttributeTransform(_ref) {
    var node = _ref.node;
    var elementStyleMap = {
      align: 'textAlign'
    };
    var attribs = (0, utilities_1.styleMapToAttribs)({
      elementStyleMap: elementStyleMap,
      node: node
    });
    return (0, utilities_1.isEmptyObject)(attribs) ? {} : attribs;
  },
  encodeEntities: true
};